import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import JobFullDetailsMainDetailsDriverBlock
  from './main-details/job-full-details-main-details-driver-block.jsx';

export default class JobFullDetailsMainDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      customerAllJobsPage:props.customerAllJobsPage || false,
    }
    this.convertNewlines = this.convertNewlines.bind(this);
    this.calculateFuelPercentages = this.calculateFuelPercentages.bind(this);
  }

  convertNewlines(input) {
    if((input!=null) && (input!==null))
    {
      return input
      .split(/\\r\\n|\\n|\\r/) // Split by newline sequences
      .map(line => line.trim()) // Trim each line
      .join('\n'); // Join lines with newline characters
    }
    else 
    {
      return '';
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  calculateFuelPercentages() {
    const { fuel_allowance, distance_in_miles } = this.state.data;

    // Check for null, blank, or NaN
    if (
      fuel_allowance === null ||
      distance_in_miles === null ||
      fuel_allowance === '' ||
      distance_in_miles === '' ||
      isNaN(fuel_allowance) ||
      isNaN(distance_in_miles) ||
      parseFloat(distance_in_miles) === 0
    ) {
      return '';
    }

    const percentage = (parseFloat(fuel_allowance) / parseFloat(distance_in_miles)).toFixed(2);
    return percentage;
  }
  render() {

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            {this.state.data.fuel_included_in_job_price === 1 ?
              <strong>Fuel Included in Job Price</strong>
              :
              <strong>Fuel Not Included in Job Price</strong>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 col-sm-12">
            <div className="subsection-container">
              <h3>Pickup Required</h3>
              <div className="time-label">
                {this.state.data.pickup_preposition.toUpperCase()}&nbsp;
                {this.state.data.pickup_day}/
                {this.state.data.pickup_month}/
                {this.state.data.pickup_year} @ {
                this.state.data.pickup_time.toUpperCase()}
              </div>
              <br />
              <br />
              <br />
              <h3>Pickup Scheduled</h3>
              <div className="time-label">
                {this.state.data.scheduled_pickup_preposition?
                  this.state.data.scheduled_pickup_preposition.
                  toUpperCase():''
                }&nbsp;
                {this.state.data.scheduled_pickup_day?
                  this.state.data.scheduled_pickup_day:''
                }/
                {this.state.data.scheduled_pickup_month?
                  this.state.data.scheduled_pickup_month:''
                }/
                {this.state.data.scheduled_pickup_year?
                  this.state.data.scheduled_pickup_year:''
                } @
                {this.state.data.scheduled_pickup_time?
                  this.state.data.scheduled_pickup_time:''
                }
              </div>
            </div>

            <div className="subsection-container">
              <h3>Pickup Address</h3>
              <p><strong>House Number or Name: </strong>
                {this.state.data.pickup_address.house_number_or_name}</p>
              <p><strong>Address Line 1: </strong>
                {this.state.data.pickup_address.address_line_1}</p>
              <p><strong>Address Line 2: </strong>
                {this.state.data.pickup_address.address_line_2}</p>
              <p><strong>Address Line 3: </strong>
                {this.state.data.pickup_address.address_line_3}</p>
              <p><strong>Town/City: </strong>
                {this.state.data.pickup_address.town_city}</p>
              <p><strong>County: </strong>
                {this.state.data.pickup_address.county_area}</p>
              <p><strong>Country: </strong>
                {this.state.data.pickup_address.country}</p>
              <p><strong>Postcode: </strong> {
                (this.state.data.pickup_address.postcode != null) ?
                  this.state.data.pickup_address.postcode.toUpperCase() :
                  null
              }</p>
              <br />
              <p>
                <strong>
                  Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.pickup_address.opening_times}
              </p>

              <p>
                <strong>
                  Compound Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.pickup_address.compound_opening_times}
              </p>

              <p>
                <strong>
                  Contact Name:
                </strong>
                <br />
                {this.state.data.pickup_address.contact_name}
              </p>

              <p>
                <strong>
                  Contact Telephone Number:
                </strong>
                <br />
                {this.state.data.pickup_address.contact_telephone_number}
              </p>
            </div>

            <div className="subsection-container">
              <h3>Vehicle</h3>
              <p><strong>Colour: </strong> {
                this.state.data.vehicle.colour
              }</p>
              <p><strong>Make: </strong> {
                this.state.data.vehicle.make
              }</p>
              <p><strong>Model: </strong> {
                this.state.data.vehicle.model
              }</p>
              <p><strong>Type: </strong> {
                (this.state.data.vehicle.type === 'van') ?
                  <i className="fa fa-truck"></i> :
                  <i className="fa fa-car"></i>
              } {this.state.data.vehicle.type} </p>
              <p><strong>Registration Number: </strong> {
                this.state.data.vehicle.registration_number}</p>
              <p><strong>MOT at: </strong> {
                this.state.data.vehicle.MOT_passed_at}</p>
              <p><strong>VIN Number: </strong> {
                this.state.data.vehicle.vin_number}</p>
              <p><strong>Sliding Door: </strong> {
                this.state.data.vehicle.sliding_door}</p>
              <p><strong>Fuel Type: </strong> {
                this.state.data.vehicle.fuel_type}</p>
              <br />
              {!this.state.customerAllJobsPage ?
              <p>
                <strong>Jet Wash Required: </strong>
                {this.state.data.jet_wash_required}
              </p>
              : ""}
              {!this.state.customerAllJobsPage ?
              <p>
                <strong>Fleet Paperwork Requirement: </strong>
                {this.state.data.fleet_paperwork_required}
              </p>
              : ""}
              {!this.state.customerAllJobsPage ?
              <p>
                <strong>Fuel included in Job Price? </strong>
                {this.state.data.fuel_included_in_job_price}
              </p>
              : ""}
              {!this.state.customerAllJobsPage ?
              <p>
                <strong>Admin Fee: </strong>
                &pound;{
                (this.state.data.admin_fee_in_pence/100).toFixed(2)
              }
              </p>
              : ""}
              {this.state.data.key_to_key_end_reg != null ? 
                <p>
                  <strong>Key To Key: </strong>
                  {this.state.data.key_to_key_end_reg}
                  <br />
                  <strong>Key To Key direction: </strong>
                  {this.state.data.key_to_key_direction}
                </p>
                : ""
              }
              {
                (this.state.data.cancelled_by_user_id != null && this.state.data.status == 'cancelled')?
                <div>
                  <p>
                    <strong>Cancelled By : </strong>
                    {this.state.data.cancelled_by.full_name}
                  </p>
                  <p>
                    <strong>Cancelled Time : </strong>
                    {this.state.data.cancelled_at}
                  </p>
                  <p>
                    <strong>Cancellation Reason : </strong>
                    {this.state.data.cancellation_reason}
                  </p>
                </div>
                :null
              }
              {
                (this.state.data.cancelled_by_user_id != null && this.state.data.status == 'aborted')?
                <div>
                  <p>
                    <strong>Aborted By : </strong>
                    {this.state.data.aborted_by.full_name}
                  </p>
                  <p>
                    <strong>Aborted Time : </strong>
                    {this.state.data.aborted_at}
                  </p>
                  <p>
                    <strong>Abortion Reason : </strong>
                    {this.state.data.abortion_reason}
                  </p>
                </div>
                :null
              }
              {
                (this.state.data.cancelled_by_user_id != null && this.state.data.status == 'deleted')?
                <div>
                  <p>
                    <strong>Deleted By : </strong>
                    {this.state.data.deleted_by.full_name}
                  </p>
                  <p>
                    <strong>Deleted Time : </strong>
                    {this.state.data.deleted_at}
                  </p>
                  <p>
                    <strong>Deletion Reason : </strong>
                    {this.state.data.deletion_reason}
                  </p>
                </div>
                :null
              }
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="subsection-container">
              <h3>Dropoff Required</h3>
              <div className="time-label">{
                this.state.data.dropoff_preposition.
                toUpperCase()
              }&nbsp;
                {this.state.data.dropoff_day}/
                {this.state.data.dropoff_month}/
                {this.state.data.dropoff_year} @ {
                  this.state.data.dropoff_time.toUpperCase()}
              </div>
              <br />
              <br />
              <br />
              <h3>Dropoff Scheduled</h3>
              <div className="time-label">
                {this.state.data.scheduled_dropoff_preposition?
                  this.state.data.scheduled_dropoff_preposition.
                  toUpperCase() : ''
                }&nbsp;
                {this.state.data.scheduled_dropoff_day?
                  this.state.data.scheduled_dropoff_day:''
                }/
                {this.state.data.scheduled_dropoff_month?
                  this.state.data.scheduled_dropoff_month:''
                }/
                {this.state.data.scheduled_dropoff_year?
                  this.state.data.scheduled_dropoff_year:''
                } @
                {this.state.data.scheduled_dropoff_time?
                  this.state.data.scheduled_dropoff_time:''
                }
              </div>
            </div>

            <div className="subsection-container">
              <h3>Dropoff Address</h3>
              <p><strong>House Number or Name:</strong> {
                this.state.data.dropoff_address.house_number_or_name
              }</p>
              <p><strong>Address Line 1:</strong> {
                this.state.data.dropoff_address.address_line_1
              }</p>
              <p><strong>Address Line 2:</strong> {
                this.state.data.dropoff_address.address_line_2
              }</p>
              <p><strong>Address Line 3:</strong> {
                this.state.data.dropoff_address.address_line_3
              }</p>
              <p><strong>Town/City:</strong> {
                this.state.data.dropoff_address.town_city
              }</p>
              <p><strong>County:</strong> {
                this.state.data.dropoff_address.county_area
              }</p>
              <p><strong>Country:</strong> {
                this.state.data.dropoff_address.country
              }</p>
              <p><strong>Postcode:</strong> {
                (this.state.data.dropoff_address.postcode != null) ?
                  this.state.data.dropoff_address.postcode.
                  toUpperCase() : null
              }
              </p>
              <br />
              <p>
                <strong>
                  Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.dropoff_address.opening_times}
              </p>

              <p>
                <strong>
                  Compound Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.dropoff_address.compound_opening_times}
              </p>

              <p>
                <strong>
                  Contact Name:
                </strong>
                <br />
                {this.state.data.dropoff_address.contact_name}
              </p>

              <p>
                <strong>
                  Contact Telephone Number:
                </strong>
                <br />
                {this.state.data.dropoff_address.contact_telephone_number}
              </p>
            </div>
            {!this.state.customerAllJobsPage ?
            <div className="subsection-container">
              <h3>Driver</h3>
              <JobFullDetailsMainDetailsDriverBlock
                data={this.state.data}
              />
            </div>
            : ""}
            <div className="subsection-container">
              <h3>3rd Party</h3>
              <div className="mb-3">
                <strong>Appraisal to be done on external system? </strong>
                <span className="ms-2">{this.state.data.appraisal_to_be_done_on_external_system ? 'YES' : 'NO'}</span>
              </div>
              <div className="mb-3">
                <strong>Name of external system for appraisal: </strong>
                <span className="ms-2">{this.state.data.name_of_external_system_for_appraisal}</span>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="subsection-container">
              <h3>Customer</h3>
              <p><strong>Name: </strong>
                <a href={"/portal-admin/customers/view/"+
                this.state.data.customer.id}>{
                  this.state.data.customer.name
                }
                </a>
              </p>
              <p><strong>VAT Number: </strong> {
                this.state.data.customer.vat_number}</p>
              <p><strong>Telephone: </strong> {
                this.state.data.customer.telephone_1}</p>
              <p><strong>Telephone: </strong> {
                this.state.data.customer.telephone_2}</p>
            </div>
            <div className="subsection-container">
              <h3>Customer Contact</h3>
              <p><strong>Name: </strong>{
                this.state.data.customer.contact_name
              }</p>
              <p><strong>Email: </strong> <a
                href={"mailto:"+
                this.state.data.customer.contact_email
                }>{this.state.data.customer.contact_email
              }</a></p>
              <p><strong>Telephone: </strong> {
                this.state.data.customer.contact_telephone_1
              }</p>
              <p><strong>Telephone: </strong> {
                this.state.data.customer.contact_telephone_2
              }</p>
            </div>
            <div className="subsection-container">
              <h3>Customer Order Number</h3>
              <p><strong>{
                this.state.data.customer_order_number
              }</strong></p>
            </div>
            <div className="subsection-container">
              <h3>Customer Job Number</h3>
              <p><strong>{
                this.state.data.customer_job_number
              }</strong></p>
            </div>
            <div className="subsection-container">
              <h3>Fuel Allowance <i data-toggle="tooltip" title="Only for Gasoline Vehicles" className="fa fa-gas-pump"></i></h3>
              <p><strong>£ {
                this.state.data.fuel_allowance
              }</strong>
              </p>
              <small>
                <i>{this.state.data.distance_in_miles} x £ {this.calculateFuelPercentages()}</i>
              </small>
            </div>
            {!this.state.customerAllJobsPage ?
            <div className="subsection-container">
              <h3>Special Instructions</h3>
              <textarea
                rows="7"
                className="form-control form-control-lg text-left"
                name="special_instructions"
                value={this.convertNewlines(this.state.data.special_instructions)}
                readOnly
                id="special_instructions"
              />
            </div>
            : ""}
            {!this.state.customerAllJobsPage ?
            <div className="subsection-container">
              <h3>Notes</h3>
              <textarea className="form-control form-control-lg"
                        defaultValue={this.state.data.notes}>
              </textarea>
            </div>
            : ""}
          </div>
        </div>
      </div>

    )
  }
}